module.exports = __webpack_public_path__ + "img/blake-1.9af6c8cf.jpg";